import type { Inventory } from "@/api/inventory/_models/Inventory";
import { NoteAlert } from "@/components/NoteAlert";
import { toInventoryListSummary } from "./inventoryListExpanded.utils";

interface InventoryListExpandedSummaryProps {
  row: Inventory;
}

/** What an inventory row's status means for it, as a note in the status's colour. */
export const InventoryListExpandedSummary = (props: InventoryListExpandedSummaryProps) => {
  const { row } = props;
  const summary = toInventoryListSummary(row);
  if (!summary) return null;

  return (
    <NoteAlert
      severity={summary.tone}
      sx={{ gridColumn: "1 / -1", mx: -1.5 }}
    >
      {summary.text}
    </NoteAlert>
  );
};
